import type { Maybe } from '@adornis/base/utilTypes.js';
import { context } from '@adornis/baseql/server/context.js';
import type { User } from '@adornis/buchungsheld-db/entities/user.js';
import { NotLoggedInError } from '@adornis/users/db/errors.js';
import { MatchingWeekRole } from '../db/enums/roles.js';

/**
 * Throws if the calling baseql user does not hold the matching-week admin role.
 * Use at the top of every admin-only resolver.
 */
export const assertCallerIsAdmin = async () => {
  if (context.serverContext) return;
  const caller = (await context.user()) as Maybe<User>;
  if (!caller) throw new NotLoggedInError();
  const isAdmin = caller.roles?.some(r => r.name === MatchingWeekRole.ADMIN);
  if (!isAdmin) throw new Error('Not authorized');
};
